<template>
    <div class="resume-download-page">
        <section ref="selectContainer" class="resume-filter-panel">
            <div class="resume-filter-options">
                <div class="headerContainer message-page-header">
                    <span>简历下载</span>
                    <span style="margin-top: 2px;" class="resume-page-refresh" :class="{'is-refreshing': resumeRefreshing}" @click="refreshResumePage">
                        刷新 <i class="el-icon-refresh"></i>
                    </span>
                </div>
                <div class="stateContainerx1">
                    <div class="title">全部职位</div>
                    <div ref="jobTags" class="job-tags" :style="{ maxWidth: jobTagsMaxWidth + 'px' }">
                        <div v-for="job in visibleJobList" :key="job.name" class="tags1 tags2"
                            :class="{ 'is-active': job.isSelect }" :title="job.name" @click="selectJob(job.name)">
                            {{ formatJobName(job.name) }}</div>
                    </div>
					<el-popover v-if="showJobMore" v-model="jobMoreVisible" placement="bottom-start" trigger="click"
                        popper-class="resume-job-more-popper">
                        <div class="job-more-list">
                            <div v-for="job in jobs" :key="'more-' + job.name"
                                :class="{ 'is-active': job.isSelect }" :title="job.name"
                                @click="selectJob(job.name)">{{ formatJobName(job.name) }}</div>
                        </div>
                        <div slot="reference" class="job-more" :class="{ 'is-active': isSelectedJobHidden }"
                            :title="moreJobName"><span>{{ moreJobName }}</span><i class="el-icon-arrow-down"></i></div>
                    </el-popover>
                </div>
                <div class="stateContainerx1 status-line">
                    <div class="title">下载状态</div>
                    <div v-for="status in statusOptions" :key="status.value" class="tags1 status-tag"
                        :class="{ 'is-active': statusIndex === status.value }"
                        @click="selectStatus(status.value)">{{ status.label }}<span
                            >{{ status.count }}</span>
                    </div>
                </div>
            </div>
            <div class="resume-filter-tools">
                <div class="resume-quota-panel">
                    <div class="resume-quota-item"><span>简历总额度</span><strong>{{ quota.total }}</strong><em>个</em></div>
                    <div class="resume-quota-item"><span>简历已用额度</span><strong>{{ quota.used }}</strong><em>个</em></div>
                    <div class="resume-quota-item" style="border-right: none;">
                        <span>简历剩余额度</span><strong>{{ quota.remaining }}</strong><em>个</em></div>
                    <!-- <div class="resume-download-button" @click="goResumeDownload">简历下载中心 <i class="el-icon-download"></i></div> -->
                </div>
                <div class="search resume-search">
                    <i class="el-icon-search"></i>
                    <input v-model="keyword" placeholder="可按姓名、学校、专业、投递职位等搜索简历" @keyup.enter="search" />
                    <button @click="search">搜索</button>
                    <button v-if="keyword" class="reset-search-button" @click="resetSearch">重置</button>
                </div>
            </div>
        </section>

        <div class="selection-bar">
            <div class="select-all-checkbox" :class="{ 'is-checked': checkAll }" @click="toggleAll(!checkAll)">
                <i class="select-all-checkbox-icon"></i><span>全选</span>
            </div>
            <span v-if="selectedRows.length" style="transform: translateY(-2px);">已选中<span
                    v-if="selectedJob !== '不限'">{{ selectedJob }}职位</span><span class="selected-count">{{ selectedRows.length }}</span>个简历文件</span>
            <!-- <div class="batch-download-button" :class="{ 'is-disabled': !selectedRows.length || batchDownloading }"
                @click="selectedRows.length && !batchDownloading && batchDownload()"><i class="el-icon-download"></i>批量下载</div> -->
            <div class="batch-download-button" :class="{ 'is-disabled': !selectedRows.length || batchDownloading }"
                @click="selectedRows.length && !batchDownloading && batchDownloadAsZip()"><i class="el-icon-download"></i>批量下载</div>
        </div>

        <section class="table-panel">
            <div class="table-scroll">
                <div v-if="loading" class="resume-table-skeleton" aria-busy="true">
                    <div class="resume-table-skeleton__row resume-table-skeleton__header">
                        <span v-for="index in 9" :key="'header-' + index" class="resume-table-skeleton__block"></span>
                    </div>
                    <div v-for="rowIndex in 8" :key="rowIndex" class="resume-table-skeleton__row">
                        <span v-for="columnIndex in 9" :key="columnIndex" class="resume-table-skeleton__block"
                            :class="{ 'is-short': columnIndex === 1 || columnIndex === 9 }"></span>
                    </div>
                </div>
                <el-table v-else ref="table" :data="rows" :row-key="rowId" :row-class-name="rowClassName"
                    @selection-change="handleSelection" empty-text="暂无简历数据">
                    <el-table-column type="selection" :reserve-selection="true" width="30"></el-table-column>
                    <el-table-column label="投递时间" min-width="130"><template
                            slot-scope="scope">{{ formatDate(scope.row) }}</template></el-table-column>
                    <el-table-column label="学生姓名" min-width="100"><template
                            slot-scope="scope">{{ displayName(scope.row) }}</template></el-table-column>
                    <el-table-column label="学校" min-width="140"><template
                            slot-scope="scope">{{ scope.row.school_name || scope.row.schoolName || scope.row.academy_name || '--' }}</template></el-table-column>
                    <el-table-column label="专业" min-width="150"><template
                            slot-scope="scope">{{ scope.row.major_name || scope.row.department || '--' }}</template></el-table-column>
                    <el-table-column label="投递职位" min-width="130"><template
                            slot-scope="scope">{{ scope.row.job_name || scope.row.job_title || '--' }}</template></el-table-column>
                    <!-- <el-table-column label="简历文件" min-width="220"><template slot-scope="scope"><span
                                class="resume-file"><i
                                    class="file-icon">PDF</i>{{ fileName(scope.row) }}</span></template></el-table-column> -->
                    <el-table-column min-width="150"><template slot="header"><span class="download-status-header">下载状态<i
                                    class="el-icon-info" @click.stop="downloadLocationVisible = true"></i></span></template><template slot-scope="scope">
                            <div class="download-state" :class="downloadState(scope.row).status">
                                <span>{{ downloadState(scope.row).label }}</span><span
                                    v-if="downloadState(scope.row).status === 'downloading'" class="progress"><i
                                        :style="{ width: downloadState(scope.row).progress + '%' }"></i></span></div>
                        </template></el-table-column>
                    <el-table-column label="下载时间" min-width="135"><template
                            slot-scope="scope">{{ formatMinute(downloadState(scope.row).time) }}</template></el-table-column>
                    <el-table-column label="操作" width="170" align="center"><template slot-scope="scope"><div class="resume-action-group"><div
                                class="resume-action-button preview-button" @click="preview(scope.row)">预览</div><div
                                class="resume-action-button download-button"
                                :class="{ 'is-disabled': batchDownloading || downloadState(scope.row).status === 'downloading' }"
                                @click="!batchDownloading && downloadState(scope.row).status !== 'downloading' && downloadOne(scope.row)">下载简历</div></div></template></el-table-column>
                </el-table>
                <div v-if="rows.length && loadingMore" class="scroll-tip">加载中...</div>
                <div v-else-if="rows.length && !hasMore" class="scroll-tip">没有更多了</div>
            </div>
        </section>
        <el-dialog :visible.sync="downloadLocationVisible" width="595px" :show-close="true"
            :close-on-click-modal="false" class="download-location-dialog">
            <div slot="title" class="download-location-dialog__title">简历下载存放位置说明</div>
            <div class="download-location-dialog__content">
                <p class="download-location-dialog__intro">各系统浏览器默认下载目录</p>
                <section class="download-location-dialog__section">
                    <h3>Windows 系统</h3>
                    <p>C:\Users\你的电脑用户名\Downloads</p>
                    <p>Chrome、Edge、Firefox、360浏览器等绝大多数浏览器，默认下载路径均为系统「下载」文件夹，完整路径：</p>
                    <p>你也可以直接打开「此电脑」，在左侧快速访问栏点击「下载」文件夹进入。</p>
                </section>
                <section class="download-location-dialog__section">
                    <h3>macOS系统</h3>
                    <p>Safari、Chrome、Edge等浏览器默认下载路径均为系统「下载」文件夹，完整路径：</p>
                    <p>/Users/你的电脑用户名/Downloads</p>
                    <p>你可以打开访达，在左侧边栏「个人收藏」中点击「下载」进入。</p>
                </section>
            </div>
            <div slot="footer" class="download-location-dialog__footer"><el-button type="primary"
                    @click="downloadLocationVisible = false">我知道了</el-button></div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    import JSZip from 'jszip'
    import {
        saveAs
    } from 'file-saver'

    export default {
        data() {
            return {
                loading: false,
                loadingMore: false,
                keyword: '',
                searchedKeyword: '',
                page: 1,
                pageSize: 500,
                total: 0,
                rows: [],
                hasMore: true,
                jobs: [{
                    name: '全部',
                    isSelect: true
                }],
                selectedJob: '全部',
                statusIndex: 0,
                jobTagsMaxWidth: 0,
                visibleJobCount: 0,
                showJobMore: false,
                jobMoreVisible: false,
                statusOptions: [{
                    value: 0,
                    label: '全部',
                    count: 0
                }, {
                    value: 1,
                    label: '已下载',
                    count: 0
                }, {
                    value: 2,
                    label: '未下载',
                    count: 0
                }],
                quotaRefreshTimer: null,
                quota: {
                    total: 0,
                    used: 0,
                    remaining: 0
                },
                resumeRefreshing: false,
                selectedRows: [],
                checkAll: false,
                downloads: {},
                batchDownloading: false,
                batchDownloadInterval: 500,
                downloadLocationVisible: false
            }
        },
        computed: {
            ...mapState({
                adminId: state => state.schoolData && state.schoolData.admin_id,
                schoolInfo: state => state.schoolData
            }),
            isIndeterminate() {
                return this.selectedRows.length > 0 && this.selectedRows.length < this.rows.length
            },
            visibleJobList() {
                return this.jobs.slice(0, this.visibleJobCount)
            },
            isSelectedJobHidden() {
                return this.jobs.findIndex(job => job.isSelect) >= this.visibleJobCount
            },
            moreJobName() {
                const selectedJob = this.jobs.find(job => job.isSelect)
                return this.isSelectedJobHidden && selectedJob ? this.formatJobName(selectedJob.name) : '更多'
            }
        },
        mounted() {
            this.htmlOverflow = document.documentElement.style.overflow
            this.bodyOverflow = document.body.style.overflow
            document.documentElement.style.overflow = 'hidden'
            document.body.style.overflow = 'hidden'
            this.scrollContainer = this.$el.closest('.rightMain')
            if (this.scrollContainer) this.scrollContainer.addEventListener('scroll', this.handlePageScroll)
            this.getJobNameList();
            this.getQuota();
            this.getList(true);
            window.addEventListener('resize', this.updateJobTagsLayout)
            this.updateJobTagsLayout()
        },
        beforeDestroy() {
            if (this.scrollContainer) this.scrollContainer.removeEventListener('scroll', this.handlePageScroll)
            window.removeEventListener('resize', this.updateJobTagsLayout)
            if (this.quotaRefreshTimer) clearTimeout(this.quotaRefreshTimer)
            document.documentElement.style.overflow = this.htmlOverflow || ''
            document.body.style.overflow = this.bodyOverflow || ''
        },
        methods: {
            updateJobTagsLayout() {
                this.visibleJobCount = this.jobs.length
                this.$nextTick(() => {
                    const selectContainer = this.$refs.selectContainer,
                        jobTags = this.$refs.jobTags
                    if (!selectContainer || !jobTags) return
                    this.jobTagsMaxWidth = Math.max(selectContainer.clientWidth - 556 - 200 - 100, 0)
                    this.$nextTick(() => {
                        let usedWidth = 0
                        let visibleCount = 0
                        Array.prototype.forEach.call(jobTags.children, tag => {
                            const style = window.getComputedStyle(tag)
                            const tagWidth = tag.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight)
                            if (usedWidth + tagWidth <= this.jobTagsMaxWidth) {
                                usedWidth += tagWidth
                                visibleCount++
                            }
                        })
                        this.visibleJobCount = visibleCount
                        this.showJobMore = visibleCount < this.jobs.length
                    })
                })
            },
            formatJobName(name) {
                const characters = Array.from(name || '')
                let length = 0
                let result = ''
                for (let index = 0; index < characters.length; index++) {
                    length += /[\u3400-\u9fff]/.test(characters[index]) ? 2 : 1
                    if (length > 14) return result + '...'
                    result += index === 0 && /[a-z]/i.test(characters[index]) ? characters[index].toUpperCase() : characters[index]
                }
                return result
            },
            getJobNameList() {
                const cacheKey = 'messageManagementJobNames_' + this.adminId + '_' + this.schoolInfo.id
                const setJobs = names => {
                    this.jobs = [{
                        name: '不限',
                        isSelect: true
                    }].concat(names.map(name => ({
                        name,
                        isSelect: false
                    })))
                    this.updateJobTagsLayout()
                }
                try {
                    const cache = JSON.parse(localStorage.getItem(cacheKey) || 'null')
                    if (Array.isArray(cache)) return setJobs(cache)
                } catch (error) {
                    localStorage.removeItem(cacheKey)
                }
                this.$util.post('v2/pc/my_job_list', {
                    admin_id: this.adminId,
                    id: this.schoolInfo.id,
                    page: 1,
                    size: 1000
                }, res => {
                    if (res.code !== 200 || !res.data || !Array.isArray(res.data.data)) return
                    const names = [...new Set(res.data.data.map(item => item.job_name).filter(Boolean))]
                    localStorage.setItem(cacheKey, JSON.stringify(names))
                    setJobs(names)
                })
            },
            getQuota() {
                this.$util.post('v2/school_job/get_admin_file_config', {
                    admin_id: this.adminId || 0
                }, res => {
                    const data = res.data || {}
                    if (!Object.prototype.hasOwnProperty.call(data, 'total_file_open_limit') ||
                        !Object.prototype.hasOwnProperty.call(data, 'file_open_limit')) return
                    const total = Number(data.total_file_open_limit),
                        remaining = Number(data.file_open_limit)
                    if (!Number.isFinite(total) || !Number.isFinite(remaining)) return
                    this.quota = {
                        total,
                        used: Math.max(total - remaining, 0),
                        remaining
                    }
                })
            },
            refreshQuotaAfterStorage() {
                if (this.quotaRefreshTimer) clearTimeout(this.quotaRefreshTimer)
                this.quotaRefreshTimer = setTimeout(() => {
                    this.quotaRefreshTimer = null
                    this.getQuota()
                }, 200)
            },
            goResumeDownload() {
                if (this.$route.path !== '/resumeDownload') this.$router.push({
                    path: '/resumeDownload'
                })
            },
            refreshResumePage() {
                if (this.resumeRefreshing) return
                const previousTotal = this.total
                this.resumeRefreshing = true
                this.getList(true, success => {
                    this.resumeRefreshing = false
                    if (!success) return
                    const newCount = Math.max(0, this.total - previousTotal)
                    this.$message.success(newCount > 0 ? '新增' + newCount + '条简历' : '暂无新增简历')
                })
                this.getQuota()
            },
            requestPayload() {
                let aaa =  this.selectedJob==='不限' ||this.selectedJob==='全部'?'':this.selectedJob
                return {
                    admin_id: this.adminId,
                    keyword: this.searchedKeyword.replace(/%/g, '') || aaa,
                    // job_title: this.selectedJob === '全部' ? '' : JSON.stringify([this.selectedJob]),
                    // score_status: Number(this.statusIndex),
                    download_status: Number(this.statusIndex),
                    size: this.pageSize,
                    page: this.page
                }
            },
            getList(reset, callback) {
                if (this.loading || this.loadingMore || (!reset && !this.hasMore)) return
                if (reset) {
                    this.page = 1
                    this.rows = []
                    this.selectedRows = []
                    this.checkAll = false
                    this.hasMore = true
                    this.loading = true
                } else {
                    this.page += 1
                    this.loadingMore = true
                }
                this.$util.post('v2/school_job/getResumeLibrary', this.requestPayload(), res => {
                    if (res.code === 200) {
                        const list = res.data && Array.isArray(res.data.data) ? res.data.data : []
                        const statistics = res.data && res.data.download_statistics ? res.data.download_statistics : {}
                        this.statusOptions[0].count = Number(statistics.total_download_cnt) || 0
                        this.statusOptions[1].count = Number(statistics.has_download_cnt) || 0
                        this.statusOptions[2].count = Number(statistics.not_download_cnt) || 0
                        const shouldSelectAll = !reset && this.checkAll
                        this.rows = reset ? list : this.rows.concat(list)
                        this.total = Number(res.data && res.data.meta && res.data.meta.total) || 0
                        this.hasMore = list.length > 0 && this.rows.length < this.total
                        if (reset) this.$nextTick(() => this.$refs.table && this.$refs.table.clearSelection())
                        else if (shouldSelectAll) this.$nextTick(() => list.forEach(row => this.$refs.table &&
                            this.$refs.table.toggleRowSelection(row, true)))
                    }
                    this.loading = false
                    this.loadingMore = false
                    if (typeof callback === 'function') callback(res.code === 200)
                }, () => {
                    this.loading = false;
                    this.loadingMore = false
                    if (typeof callback === 'function') callback(false)
                })
            },
            selectJob(name) {
				this.jobMoreVisible = false
				this.selectedJob = name;
                this.jobs.forEach(job => {
                    job.isSelect = job.name === name
                });
                this.getList(true);
            },
            selectStatus(value) {
                this.statusIndex = value;
                this.getList(true);
            },
            search() {
                this.searchedKeyword = this.keyword;
                this.getList(true);
            },
            resetSearch() {
                this.keyword = ''
                this.searchedKeyword = ''
                this.getList(true)
            },
            handlePageScroll() {
                const target = this.scrollContainer
                if (!target) return
                if (target.scrollTop + target.clientHeight >= target.scrollHeight - 48) this.getList(false)
            },
            handleSelection(rows) {
                this.selectedRows = rows;
                this.checkAll = this.rows.length > 0 && this.rows.every(row => rows.some(item => this.rowId(item) === this.rowId(row)))
            },
            toggleAll(checked) {
                if (!checked) return this.$refs.table.clearSelection()
                this.rows.forEach(row => this.$refs.table.toggleRowSelection(row, true))
            },
            rowId(row) {
                return row.id || row.user_record_id || row.url
            },
            displayName(row) {
                return row.realname || row.username || row.name || '--'
            },
            formatDate(row) {
                return this.formatMinute(row.delivery_time || row.created_at || row.create_time || row.add_time)
            },
            formatMinute(time) {
                if (!time) return '--'
                const value = String(time)
                const match = value.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[T\s]+(\d{1,2}):(\d{2}))?/)
                if (match) {
                    const pad = number => String(number).padStart(2, '0')
                    return `${match[1]}/${pad(match[2])}/${pad(match[3])}${match[4] ? ` ${pad(match[4])}:${match[5]}` : ''}`
                }
                return value.replace(/(\d{1,2}:\d{2}):\d{2}(?=(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$)/, '$1')
            },
            downloadFileName(row) {
                const fileUrl = row.url || ''
                const urlName = decodeURIComponent(fileUrl.split('?')[0].split('/').pop() || '')
                const extension = (urlName.match(/\.[^.]+$/) || [''])[0]
                const name = this.displayName(row)
                const school = row.school_name || row.schoolName || row.academy_name || ''
                const jobName = row.job_name || row.job_title || ''
                return (name + '_' + school + '_' + jobName).replace(/[\\/:*?"<>|]/g, '') + extension
            },
            fileName(row) {
                const name = this.downloadFileName(row)
                const match = name.match(/^(.*?)(\.[^.]+)$/)
                const title = match ? match[1] : name
                const extension = match ? match[2] : ''
                let length = 0
                let display = ''
                let truncated = false
                for (const char of Array.from(title)) {
                    const charLength = /[\u4e00-\u9fff]/.test(char) ? 2 : 1
                    if (length + charLength > 12) {
                        truncated = true;
                        break
                    }
                    display += char
                    length += charLength
                }
                return (truncated ? display + '...' : display) + extension
            },
            downloadState(row) {
                if (this.downloads[this.rowId(row)]) return this.downloads[this.rowId(row)]
                const downloaded = row.download_status === 1 || row.download_status === '1' || row
                    .file_download_status === 1 || row.is_downloaded === 1 || row.download_time
                return downloaded ? {
                    status: 'done',
                    label: '已下载',
                    progress: 100,
                    time: row.download_time || row.file_download_time || ''
                } : {
                    status: 'pending',
                    label: '未下载',
                    progress: 0,
                    time: ''
                }
            },
            refreshDownloadCounts() {},
            rowClassName({
                row
            }) {
                return this.selectedRows.some(item => this.rowId(item) === this.rowId(row)) ? 'is-selected-row' : ''
            },
            preview(row) {
                if (row.url) window.open(row.url, '_blank');
                else this.$message.warning('暂无可预览的简历')
            },
            setDownload(row, state) {
                this.$set(this.downloads, this.rowId(row), state);
                this.refreshDownloadCounts()
            },
            async downloadOne(row) {
                if (!row || !row.id || !await this.requestViewDownloadPermission(row)) return
                return this.downloadFile(row)
            },
            showQuotaWarning() {
                this.$alert('额度不足，暂不能下载', '提示', {
                    confirmButtonText: '确定',
                    showClose: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false
                })
            },
            requestViewDownloadPermission(row) {
                return new Promise(resolve => {
                    this.$util.post('v2/school_job/viewDownloadFile', {
                        admin_id: this.adminId || 0,
                        file_id: row.id,
                        opt_type: 2
                    }, res => {
                        if (res && Number(res.code) === 0) {
                            this.refreshQuotaAfterStorage()
                            return resolve(true)
                        }
                        this.showQuotaWarning()
                        resolve(false)
                    }, null, () => resolve(false))
                })
            },
            requestBatchDownloadPermission(fileIdArr) {
                return new Promise(resolve => {
                    this.$util.post('v2/school_job/batchDownloadFile', {
                        admin_id: this.adminId || 0,
                        file_id_arr: JSON.stringify(fileIdArr)
                    }, res => {
                        if (res && Number(res.code) === 0) {
                            this.refreshQuotaAfterStorage()
                            return resolve(true)
                        }
                        this.showQuotaWarning()
                        resolve(false)
                    }, null, () => resolve(false))
                })
            },
            async batchDownload() {
                const items = this.selectedRows.filter(row => row.url && this.downloadState(row).status !==
                    'downloading')
                if (!items.length) return
                const fileIdArr = items.map(row => row.id).filter(id => id !== undefined && id !== null)
                if (!fileIdArr.length || !await this.requestBatchDownloadPermission(fileIdArr)) return
                items.forEach(row => this.setDownload(row, {
                    status: 'downloading',
                    label: '正在下载',
                    progress: 0,
                    time: ''
                }))
                this.batchDownloading = true
                try {
                    for (let index = 0; index < items.length; index++) {
                        await this.downloadFile(items[index], true)
                        if (index < items.length - 1) await this.wait(this.batchDownloadInterval)
                    }
                } finally {
                    this.batchDownloading = false
                }
            },
            async batchDownloadAsZip() {
                const items = this.selectedRows.filter(row => row.url && this.downloadState(row).status !==
                    'downloading')
                if (!items.length) return
                const fileIdArr = items.map(row => row.id).filter(id => id !== undefined && id !== null)
                if (!fileIdArr.length || !await this.requestBatchDownloadPermission(fileIdArr)) return
                if (items.length <= 5) {
                    this.batchDownloading = true
                    try {
                        for (let index = 0; index < items.length; index++) {
                            await this.downloadFile(items[index])
                            if (index < items.length - 1) await this.wait(this.batchDownloadInterval)
                        }
                    } finally {
                        this.batchDownloading = false
                    }
                    return
                }
                items.forEach(row => this.setDownload(row, {
                    status: 'downloading',
                    label: '正在下载',
                    progress: 0,
                    time: ''
                }))
                this.batchDownloading = true
                try {
                    const zip = new JSZip()
                    const fileNames = {}
                    for (let index = 0; index < items.length; index++) {
                        const row = items[index]
                        const response = await fetch(row.url)
                        if (!response.ok) throw new Error('下载失败')
                        const originalName = this.downloadFileName(row)
                        const count = fileNames[originalName] || 0
                        fileNames[originalName] = count + 1
                        const dotIndex = originalName.lastIndexOf('.')
                        const name = count ? (dotIndex > -1 ? originalName.slice(0, dotIndex) + `(${count})` + originalName.slice(dotIndex) : originalName + `(${count})`) : originalName
                        zip.file(name, await response.blob())
                        this.setDownload(row, {
                            status: 'downloading',
                            label: '正在下载',
                            progress: Math.min(95, Math.round((index + 1) / items.length * 95)),
                            time: ''
                        })
                    }
                    saveAs(await zip.generateAsync({
                        type: 'blob'
                    }), '简历文件.zip')
                    items.forEach(row => this.setDownload(row, {
                        status: 'done',
                        label: '已下载',
                        progress: 100,
                        time: this.now()
                    }))
                } catch (error) {
                    items.forEach(row => this.setDownload(row, {
                        status: 'pending',
                        label: '未下载',
                        progress: 0,
                        time: ''
                    }))
                    this.$message.error('压缩包下载失败，请稍后重试')
                } finally {
                    this.batchDownloading = false
                }
            },
            wait(time) {
                return new Promise(resolve => setTimeout(resolve, time))
            },
            async downloadFile(row, forceDownload) {
                if (!row.url || (!forceDownload && this.downloadState(row).status === 'downloading')) return
                this.setDownload(row, {
                    status: 'downloading',
                    label: '正在下载',
                    progress: 5,
                    time: ''
                })
                try {
                    const response = await fetch(row.url)
                    if (!response.ok) throw new Error('下载失败')
                    const total = Number(response.headers.get('content-length')) || 0
                    if (!response.body || !response.body.getReader) throw new Error('不支持进度读取')
                    const reader = response.body.getReader(),
                        chunks = [];
                    let received = 0
                    while (true) {
                        const result = await reader.read()
                        if (result.done) break
                        chunks.push(result.value);
                        received += result.value.length
                        this.setDownload(row, {
                            status: 'downloading',
                            label: '正在下载',
                            progress: total ? Math.min(95, Math.round(received / total * 100)) : 55,
                            time: ''
                        })
                    }
                    const blob = new Blob(chunks),
                        link = document.createElement('a')
                    link.href = URL.createObjectURL(blob);
                    link.download = this.downloadFileName(row);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href)
                    this.setDownload(row, {
                        status: 'done',
                        label: '已下载',
                        progress: 100,
                        time: this.now()
                    })
                } catch (error) {
                    const link = document.createElement('a')
                    link.href = row.url;
                    link.target = '_blank';
                    link.download = this.downloadFileName(row);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link)
                    this.setDownload(row, {
                        status: 'done',
                        label: '已下载',
                        progress: 100,
                        time: this.now()
                    })
                }
            },
            now() {
                const d = new Date(),
                    pad = n => String(n).padStart(2, '0');
                return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
            }
        }
    }
</script>

<style lang="less" scoped>
    .resume-download-page {
        min-height: 100%;
        padding: 14px 12px 36px;
        box-sizing: border-box;
        background: #f3f6fb;
        color: #303133;
    }

    .table-panel {
        background: #fff;
        border-radius: 10px;
    }

    .resume-filter-panel {
        display: flex;
        box-sizing: border-box;
        align-items: flex-start;
        justify-content: space-between;
        gap: 28px;
        min-width: 1150px;
        margin: 0 0 0;
        padding: 0 28px 18px;
        background: #fff;
        border-radius: 0 0 10px 10px;
    }

    .resume-filter-options {
        flex: 1;
        min-width: 0;
    }

    .stateContainerx1 {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
        white-space: nowrap;
    }

    .stateContainerx1 .title { flex: 0 0 auto; font-weight: 600; font-size: 14px; color: #303133; }
    .stateContainerx1 .tags1 { display: inline-flex; align-items: center; justify-content: center; height: 26px; padding: 0 12px; margin-left: 8px; font-size: 14px; font-weight: 400; color: #606266; border-radius: 17px; box-sizing: border-box; cursor: pointer; transition: background-color .2s, color .2s; }
    .stateContainerx1 .tags1.is-active { background: #e8f3ff; color: #1677ff; font-weight: 600; }
    .stateContainerx1 .tags1.is-active span { padding: 0 3px; border-radius: 10px; background: #fff; }
    .tags2 { flex: 0 0 auto; max-width: 150px; margin-right: 0; overflow: hidden; text-overflow: ellipsis; }
    .status-line { margin-top: 10px; }

    .job-tags {
        display: flex;
        flex: none;
        overflow: hidden;
    }

    .job-more { display: flex; align-items: center; max-width: 150px; margin-left: 8px; padding: 8px 4px; color: #606266; font-size: 14px; cursor: pointer; }
    .job-more span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .job-more.is-active { color: #1677ff; font-weight: 600; }
    .status-tag { gap: 6px; }
    .status-tag span { font-size: 13px; color: #909399; }
    .status-tag.is-active { background: #fdefef !important; color: #c03636 !important; }
    .status-tag.is-active span { color: #c03636; }

    .resume-filter-tools { width: 450px; flex: 0 0 450px; margin-top: 26px; }

    .resume-quota-panel {
        display: flex;
        align-items: center;
        height: 50px;
        margin-bottom: 16px;
        overflow: hidden;
        border-radius: 10px;
    }

    .resume-quota-item {
        flex: 1;
        min-width: 0;
        text-align: center;
        height: 55px;
        padding-top: 8px;
        box-sizing: border-box;
        font-size: 13px;
        color: #1f2937;
        line-height: 20px;
        background: #f3f6fb;
    }

    .resume-quota-item:nth-of-type(1), .resume-quota-item:nth-of-type(3) { position: relative; }
    .resume-quota-item:nth-of-type(1) { border-radius: 10px 0 0 10px; }
    .resume-quota-item:nth-of-type(3) { border-radius: 0 10px 10px 0; }
    .resume-quota-item:nth-of-type(1)::after, .resume-quota-item:nth-of-type(3)::after { position: absolute; top: 15px; width: 1px; height: 26px; content: ''; background: #dfe5ef; }
    .resume-quota-item:nth-of-type(1)::after { right: 0; }
    .resume-quota-item:nth-of-type(3)::after { left: 0; }

    .resume-quota-item span,
    .resume-quota-item strong,
    .resume-quota-item em {
        display: block;
        font-style: normal;
    }

    .resume-quota-item strong {
        display: inline;
        font-size: 16px;
        font-weight: 600;
        color: #1677ff;
    }

    .resume-quota-item em {
        display: inline;
        font-size: 10px;
        color: #6b7280;
    }

    .resume-download-button {
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 136px;
        margin-left: 10px;
        background: #1677ff;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
    }

    .resume-download-button i {
        margin-left: 5px;
        font-size: 16px;
    }

    .resume-search {
        display: flex;
        align-items: center;
        height: 40px;
        padding: 0 10px;
        border-radius: 5px;
        background: #f0f4fa;
    }

    .resume-search i {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        color: #606266;
        font-size: 20px;
    }

    .resume-search input {
        flex: 1;
        min-width: 0;
        margin-right: 10px;
        padding: 0;
        border: 0;
        outline: 0;
        background: transparent;
        font-size: 14px;
    }

    .resume-search button {
        width: 30px;
        border: 0;
        background: transparent;
        color: #1e40af;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
    }

    .resume-search .reset-search-button { margin-left: 5px; }

    .selection-bar {
        position: sticky;
        top: 0;
        z-index: 10;
        display: flex;
        align-items: center;
        gap: 8px;
        height: 52px;
        padding-left: 22px;
        background: #f3f6fb;
        font-size: 13px;
        color: #303133;
    }

    .selection-bar .select-all-checkbox {
        display: flex;
        align-items: center;
        margin-right: 0;
        font-size: 13px;
        font-weight: bold;
        color: #303133;
        cursor: pointer;
    }

    .selection-bar .select-all-checkbox-icon {
        display: block;
        width: 20px;
        height: 20px;
        margin-right: 6px;
        border: 0;
        background: url('https://oss.sx985.com/2026/06/12/select8202.png') center / 20px 20px no-repeat;
    }

    .selection-bar .select-all-checkbox.is-checked .select-all-checkbox-icon {
        background-image: url('https://oss.sx985.com/2026/06/12/select8201.png');
    }

    .selected-count {
        margin: 0 4px;
        color: #1685f5;
        font-size: 15px;
        font-weight: 600;
            transform: translateY(-2px);
                // transform: translateY(-2px);
    }

    .selection-bar .batch-download-button {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 28px;
        margin-left: 4px;
        padding: 0 10px;
        border-radius: 4px;
        background: #1685f5;
        color: #fff;
        font-size: 13px;
        line-height: 28px;
        cursor: pointer;
        box-sizing: border-box;
    }

    .selection-bar .batch-download-button .el-icon-download {
        margin-right: 4px;
        font-size: 14px;
    }

    .selection-bar .batch-download-button.is-disabled {
        background: #9dcef9;
        cursor: not-allowed;
    }

    .table-panel {
        padding: 12px 14px 22px;
        overflow: hidden;
    }

    .table-scroll /deep/ .el-table {
        width: 100%;
        min-width: 1120px;
    }

    .resume-table-skeleton {
        min-width: 1120px;
        overflow: hidden;
        border: 1px solid #ebeef5;
        border-bottom: 0;
        border-radius: 4px 4px 0 0;
        background: #fff;
    }

    .resume-table-skeleton__row {
        display: grid;
        grid-template-columns: 30px 1.1fr .85fr 1.2fr 1.25fr 1.1fr 1.15fr 1.15fr 170px;
        align-items: center;
        column-gap: 18px;
        height: 58px;
        padding: 0 18px;
        border-bottom: 1px solid #ebeef5;
        box-sizing: border-box;
    }

    .resume-table-skeleton__header {
        background: #f1f4fa;
    }

    .resume-table-skeleton__block {
        display: block;
        height: 16px;
        border-radius: 4px;
        background: linear-gradient(90deg, #edf1f6 25%, #f7f9fc 37%, #edf1f6 63%);
        background-size: 400% 100%;
        animation: resume-skeleton-loading 1.4s ease infinite;
    }

    .resume-table-skeleton__header .resume-table-skeleton__block {
        height: 14px;
        background: #dfe5ef;
        animation: none;
    }

    .resume-table-skeleton__block.is-short {
        width: 62%;
        justify-self: center;
    }

    @keyframes resume-skeleton-loading {
        0% { background-position: 100% 50%; }
        100% { background-position: 0 50%; }
    }

    .resume-file {
        display: flex;
        align-items: center;
        white-space: nowrap;
    }

    .file-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 21px;
        height: 24px;
        margin-right: 8px;
        border-radius: 4px;
        background: #ff4d55;
        color: #fff;
        font-size: 7px;
        font-style: normal;
    }

    .download-state {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: #5a6374;
    }

    .download-state.done {
        color: #5a6374;
    }

    .download-state.downloading {
        color: #545b66;
    }

    .progress {
        width: 62px;
        height: 4px;
        overflow: hidden;
        border-radius: 2px;
        background: #dcecff;
    }

    .progress i {
        display: block;
        height: 100%;
        border-radius: 2px;
        background: #1685f5;
        transition: width .15s ease;
    }

    .table-panel /deep/ .el-table th {
        height: 58px;
        background: #f1f4fa;
        color: #000;
        font-weight: 600;
    }

    .table-panel /deep/ .el-table__header-wrapper .el-table__header th .cell {
        color: #000 !important;
        font-weight: 700 !important;
    }

    .table-panel /deep/ .el-table td {
        height: 58px;
        color: #5a6374;
        font-size: 14px;
    }

    .table-panel /deep/ .el-table .cell {
        white-space: nowrap;
        text-align: center;
    }

    .download-status-header {
        display: inline-flex;
        align-items: center;
    }

    .download-status-header .el-icon-info {
        margin-left: 5px;
        color: #8b95a7;
        font-size: 15px;
        cursor: pointer;
    }

    .download-location-dialog /deep/ .el-dialog {
        overflow: hidden;
        border-radius: 10px;
    }

    .download-location-dialog /deep/ .el-dialog__header {
        padding: 22px 34px 16px;
        text-align: center;
    }

    .download-location-dialog /deep/ .el-dialog__headerbtn {
        top: 20px;
        right: 16px;
    }

    .download-location-dialog /deep/ .el-dialog__close {
        color: #303133;
        font-size: 18px;
    }

    .download-location-dialog /deep/ .el-dialog__body {
        padding: 8px 33px 0;
    }

    .download-location-dialog /deep/ .el-dialog__footer {
        padding: 24px 20px 20px;
        text-align: center;
    }

    .download-location-dialog__title {
        color: #303133;
        font-size: 18px;
        font-weight: 600;
        line-height: 25px;
    }

    .download-location-dialog__content {
        color: #24292f;
        font-size: 14px;
        line-height: 24px;
    }

    .download-location-dialog__content p {
        margin: 0;
    }

    .download-location-dialog__intro {
        margin-bottom: 14px !important;
        font-weight: 600;
    }

    .download-location-dialog__section + .download-location-dialog__section {
        margin-top: 24px;
    }

    .download-location-dialog__section h3 {
        margin: 0 0 3px;
        color: #1f2329;
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
    }

    .download-location-dialog__footer /deep/ .el-button {
        min-width: 97px;
        height: 34px;
        padding: 0 18px;
        border-radius: 5px;
        background: #2449b8;
        border-color: #2449b8;
        font-size: 14px;
    }

    .table-panel /deep/ .el-table .is-selected-row td {
        background: #eaf3ff !important;
    }

    @media screen and (max-width: 1200px) {
        .filter-panel {
            display: block;
        }

        .filter-tools {
            width: 100%;
            margin-top: 18px;
        }

        .filter-option {
            margin-right: 14px;
        }
    }

    .message-page-header {
		display: flex;
        font-weight: bold;
        font-size: 16px;
        color: #333;
        box-sizing: border-box;
        // height: 60px;
        padding-top: 20px;
        align-items: flex-start !important;
        margin-bottom: 20px;
        position: relative;
        // margin-top: 2px;
        &::after {
            width: 4px;
            height: 14px;
            left: -10px;
            top: 25px;
            position: absolute;
            content: "";
            background: #1e40af;
            border-radius: 2px;
        }
    }

    .table-panel /deep/ .el-table-column--selection .cell {
        padding-right: 0;
        padding-left: 10px;
    }

    .resume-page-refresh {
        margin-left: 16px;
        font-size: 14px;
        font-weight: normal;
        color: #606266;
        cursor: pointer;
    }

    .resume-page-refresh i { margin-left: 0; }
    .resume-page-refresh.is-refreshing i { animation: resume-page-refresh-loading .8s linear infinite; }

    @keyframes resume-page-refresh-loading {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }

    .table-panel /deep/ .resume-action-group {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
    }

    .table-panel /deep/ .resume-action-button {
        flex: 0 0 68px;
        width: 68px;
        height: 28px;
        padding: 0;
        border-radius: 4px;
        font-size: 14px;
        line-height: 28px;
        box-sizing: border-box;
        cursor: pointer;
    }

    .table-panel /deep/ .preview-button {
        border: 1px solid #b9dcff;
        border-color: #b9dcff;
        background: #f3f9ff;
        color: #1685f5;
    }

    .table-panel /deep/ .preview-button:hover,
    .table-panel /deep/ .preview-button:focus {
        border-color: #1685f5;
        background: #eaf4ff;
        color: #1685f5;
    }

    .table-panel /deep/ .download-button {
        border-color: #1685f5;
        background: #1685f5;
        color: #fff;
        font-size: 14px !important;
    }

    .table-panel /deep/ .download-button:hover,
    .table-panel /deep/ .download-button:focus {
        border-color: #0877e6;
        background: #0877e6;
        color: #fff;
    }

    .table-panel /deep/ .download-button.is-disabled {
        border-color: #9dcef9;
        background: #9dcef9;
        color: #fff;
    }

    .scroll-tip {
        padding: 16px 0 4px;
        color: #999;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
    }
</style>

<style>
    .resume-job-more-popper {
        max-width: 480px;
    }

    .resume-job-more-popper .job-more-list {
        display: flex;
        flex-wrap: wrap;
        gap: 12px 16px;
        font-size: 14px;
    }

    .resume-job-more-popper .job-more-list>div {
        cursor: pointer;
    }
</style>
